import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { get, map, filter, includes, size } from "lodash";

import Grid from "@material-ui/core/Grid";

import DashboardCard from "../DashboardCard";
import DashboardDoughnut from "../DashboardDoughnut";
import DoughnutLegend from "../DoughnutLegend";

import { calculatePercentage } from "../../../utils/data";

import { sizes } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  doughnutContainer: {
    margin: "0px 20px",
    display: "flex",
    alignItems: "center",
  },
};

const HspCurrentDecisions = (props) => {
  const { classes, tableFilters, setTableFilters } = props;
  const [data, setData] = React.useState({});

  React.useEffect(() => {
    if (props.data) {
      setData({
        onsiteresults: {
          allowed: {
            total: size(
              filter(props.data, (item) =>
                includes([43], get(item, ["main", "entryStatusId"]))
              )
            ),
          },
          assistance: {
            total: size(
              filter(props.data, (item) =>
                includes([93], get(item, ["main", "entryStatusId"]))
              )
            ),
          },
          denied: {
            total: size(
              filter(props.data, (item) =>
                includes([44], get(item, ["main", "entryStatusId"]))
              )
            ),
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.data)]);

  const doughnutColors = [
    colors.greenDoughnut,
    colors.orangeAssistance,
    colors.errorRed,
  ];

  const changeTableFilters = (ids) => {
    setTableFilters(
      update(tableFilters, {
        105: { $set: ids },
      })
    );
  };

  return (
    <DashboardCard
      title={I18n.get("dashboard_onsiteDecision")}
      size={sizes.small}
    >
      <Grid container justify="center" alignItems="center">
        <Grid item className={classes.doughnutContainer}>
          <DashboardDoughnut
            values={[
              get(data, ["onsiteresults", "allowed", "total"]),
              get(data, ["onsiteresults", "assistance", "total"]),
              get(data, ["onsiteresults", "denied", "total"]),
            ]}
            total={
              get(data, ["onsiteresults", "allowed", "total"]) +
              get(data, ["onsiteresults", "assistance", "total"]) +
              get(data, ["onsiteresults", "denied", "total"])
            }
            colors={doughnutColors}
            onClick={() => changeTableFilters([43, 44, 93])}
          />
        </Grid>
        <Grid
          item
          style={{ marginLeft: "10px", padding: "0px 14px", minWidth: "160px" }}
        >
          <Grid container direction="column">
            {map(["allowed", "assistance", "denied"], (type, index) => (
              <DoughnutLegend
                key={type}
                color={doughnutColors[index]}
                title={I18n.get(
                  `dashboard_${
                    type === "assistance" ? "requireAssistance" : type
                  }`
                )}
                value={get(data, ["onsiteresults", type, "total"])}
                percentage={calculatePercentage(
                  get(data, ["onsiteresults", type, "total"]),
                  get(data, ["onsiteresults", "allowed", "total"]) +
                    get(data, ["onsiteresults", "assistance", "total"]) +
                    get(data, ["onsiteresults", "denied", "total"])
                )}
                onClick={() =>
                  changeTableFilters([
                    type === "assistance" ? 93 : type === "allowed" ? 43 : 44,
                  ])
                }
              />
            ))}
          </Grid>
        </Grid>
      </Grid>
    </DashboardCard>
  );
};

export default withStyles(styles)(HspCurrentDecisions);
